export default class LearningCourseSchedule {
    public Id = 0;
    public LearningCourseId = 0;
    public LearningTypeId = 0;
    public DateFrom = new Date();
    public DateTill: Date | null = null;
    public Status = '';
    public Price = 0;
    public Enabled = false;
    public Visible = false;

    constructor(row : LearningCourseSchedule | null = null) {
        if (!row) {
            return;
        }
        this.Id = row.Id;
        this.Price = row.Price;
        this.LearningCourseId = row.LearningCourseId;
        this.LearningTypeId = row.LearningTypeId;
        this.DateFrom = new Date(row.DateFrom);
        if (row.DateTill) {
            this.DateTill = new Date(row.DateTill);
        }
        this.Status = row.Status;
        this.Enabled = row.Enabled;                
        this.Visible = row.Visible;                
    }
}